import React from "react";
import "./dropdown.css"
import "./Button"
import Button from "./Button";
import Backlogbool  from "./Backlogbool";
import BacklogCount from "./Backlogbool";
// Removed @import as it belongs in the CSS file


function Dropdown(){
    return( 

        <div className="semCount-container">
            <div class="duration-selection">
            <p>Up to which semester you want to calculate CGPA?</p>
        </div>

    <div class="radio-buttons sem-grid">
      <label class="radio-button">
    <input type="radio" name="options" value="1"></input>
    <div class="radio-circle"></div>
    <span class="radio-label">1</span>
  </label>
  <label class="radio-button">
    <input type="radio" name="options" value="2"></input>
    <div class="radio-circle"></div>
    <span class="radio-label">2</span>
  </label>
  <label class="radio-button">
    <input type="radio" name="options" value="3"></input>
    <div class="radio-circle"></div>
    <span class="radio-label">3</span>
  </label>
  <label class="radio-button">
    <input type="radio" name="options" value="4"></input>
    <div class="radio-circle"></div>
    <span class="radio-label">4</span>
  </label>
  <label class="radio-button">
    <input type="radio" name="options" value="5"></input>
    <div class="radio-circle"></div>
    <span class="radio-label">5</span>
  </label>
  <label class="radio-button">
    <input type="radio" name="options" value="6"></input>
    <div class="radio-circle"></div>
    <span class="radio-label">6</span>
  </label>
  <label class="radio-button">
    <input type="radio" name="options" value="7"></input>
    <div class="radio-circle"></div>
    <span class="radio-label">7</span>
  </label>
  <label class="radio-button">
    <input type="radio" name="options" value="8"></input>
    <div class="radio-circle"></div>
    <span class="radio-label">8</span>
  </label>
  <label class="radio-button">
    <input type="radio" name="options" value="9"></input>
    <div class="radio-circle"></div>
    <span class="radio-label">9</span>
  </label>
  <label class="radio-button">
    <input type="radio" name="options" value="10"></input>
    <div class="radio-circle"></div>
    <span class="radio-label">10</span>
  </label>
</div>

<div className="backlogBool">
  <p>Do you have any backlog?</p>
  <div className="backlogbool-options">
    <Backlogbool/>
  </div>
</div>

<div class="button-container">
 <Button/>
</div>

 </div>

 );
}

export default Dropdown;